import { IconButton, Badge, useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import clsx from 'clsx';
import useStyles from '../styles';
import { requiredLogin } from '../../../../middlewares';
import AppButton from 'components/atoms/Button';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { TranslationKey } from '../configuration';
import { useHistory } from 'react-router';
import NavigationConfig from 'navigation/config';
import NavigationActions from 'redux/reducers/gl_navigation_reducer/actions';
import { useDispatch } from 'react-redux';
import useMobile from 'hooks/useMobile';
import { APP_COLOR_SECONDARY } from 'styles/colors';

const RegisterLoginButton = () => {
  const classes = useStyles({});
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useMobile();

  return (
    <AppButton
      variant="outlined"
      color="inherit"
      onClick={() =>
        dispatch(NavigationActions.showUserMenuAction({ visible: true }))
      }
      style={{
        width: isMobile ? '100px' : 'auto',
        fontSize: isMobile ? '0.75rem' : '1rem',
        backgroundColor: APP_COLOR_SECONDARY({
          darkMode: theme.palette.type === 'dark',
          transparency: 1,
        }),
        color: 'white',
      }}
      text={
        <TranslatedTextV2
          translationKey={`${TranslationKey}.registerLogin`}
          defaultText="Register / Login"
        />
      }
    />
  );
};

export default requiredLogin(RegisterLoginButton, false);
